
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.453 4.328H.953v-.766L4.164.43l.461.43-1.773 2.43h9.601v1.038zM.953 6.531h11.5v.774l-3.21 3.133-.462-.43 1.774-2.438H.953V6.531z","fill":"currentColor"}})])
          )
        }
      }
    